import { css } from '@emotion/react';

export default css({
  '&.fb-uploaded-icon': {
    width: '30px',
    height: '30px',
    borderRadius: '4px',
    alignItems: 'center',
  },
  '.fb-uploaded-icon__icon': {
    height: '20px',
    width: 'auto',
  },
});
